module.exports = __webpack_public_path__ + "img/refuel.4c48c593.png";